import React, { useEffect } from 'react'
import { getUserInfoSync } from '../../config/api'

const SideBar = ({ activeScreen, setActiveScreen, isFirstLogin }) => {
  const userInfo = getUserInfoSync()
  const firstLogin = isFirstLogin || userInfo?.first_login === true

  const handleMenuClick = (screen) => {
    // If first login, only allow profile screen
    if (firstLogin && screen !== 'profile') {
      return
    }
    setActiveScreen(screen)
  }

  const isActive = (screenOrScreens) => {
    if (Array.isArray(screenOrScreens)) {
      return screenOrScreens.includes(activeScreen) ? '' : 'collapsed'
    }
    return activeScreen === screenOrScreens ? '' : 'collapsed'
  }

  const isSubActive = (screen) => {
    return activeScreen === screen ? 'active' : ''
  }

  const isExpanded = (screens) => {
    return screens.includes(activeScreen) ? 'collapse show' : 'collapse'
  }

  // Ensure parent menus are expanded when a sub-item is active
  useEffect(() => {
    const menuMappings = {
      'stock-levels': '#stock-management-nav',
      'view-stock': '#stock-management-nav',
      'low-stock-items': '#stock-management-nav',
      'stock-intake': '#stock-management-nav',
      'stock-out': '#stock-management-nav',
      'stock-adjustments': '#stock-management-nav',
      'request-stock': '#stock-transfers-nav',
      'new-transfer': '#stock-transfers-nav',
      'pending-transfers': '#stock-transfers-nav',
      'outgoing-transfers': '#stock-transfers-nav',
      'incoming-transfers': '#stock-transfers-nav',
      'transfer-history': '#stock-transfers-nav',
      'branch-requests': '#branch-requests-nav',
      'requests-history': '#branch-requests-nav',
      'purchase-order-receiving': '#receiving-goods-nav',
      'supplier-returns': '#receiving-goods-nav',
      'goods-received-notes': '#receiving-goods-nav',
    }

    const targetId = menuMappings[activeScreen]
    if (targetId) {
      const collapseElement = document.querySelector(targetId)
      if (collapseElement && window.bootstrap && window.bootstrap.Collapse) {
        let bsCollapse = window.bootstrap.Collapse.getInstance(collapseElement)
        if (!bsCollapse) {
          bsCollapse = new window.bootstrap.Collapse(collapseElement, { toggle: false })
        }
        if (!collapseElement.classList.contains('show')) {
          bsCollapse.show()
        }
      }
    }
  }, [activeScreen])

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        {/* Dashboard */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive('dashboard')} ${firstLogin ? 'disabled' : ''}`}
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('dashboard'); }}
            style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <i className="bi bi-grid" />
            <span>Dashboard</span>
          </a>
        </li>{/* End Dashboard Nav */}
        
        {/* Stock Management */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive(['stock-levels', 'view-stock', 'low-stock-items', 'stock-intake', 'stock-out', 'stock-adjustments'])} ${firstLogin ? 'disabled' : ''}`}
            data-bs-target="#stock-management-nav" 
            data-bs-toggle={firstLogin ? '' : 'collapse'} 
            href="#"
            onClick={(e) => { e.preventDefault(); }}
            style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <i className="bi bi-box-seam" />
            <span>Stock Management</span>
            <i className="bi bi-chevron-down ms-auto" />
          </a>
          <ul id="stock-management-nav" className={`nav-content ${isExpanded(['stock-levels', 'view-stock', 'low-stock-items', 'stock-intake', 'stock-out', 'stock-adjustments'])}`} data-bs-parent="#sidebar-nav">
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('view-stock'); }}
                className={isSubActive('view-stock')}
              >
                <i className="bi bi-circle" />
                <span>View Stock</span>
              </a>
            </li>
            
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('low-stock-items'); }}
                className={isSubActive('low-stock-items')}
              >
                <i className="bi bi-circle" />
                <span>Low Stock Items</span>
              </a>
            </li>
           
          
          </ul>
        </li>{/* End Stock Management Nav */}
        
        {/* Stock Transfers */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive(['request-stock', 'pending-transfers', 'outgoing-transfers', 'incoming-transfers', 'transfer-history'])} ${firstLogin ? 'disabled' : ''}`}
            data-bs-target="#stock-transfers-nav" 
            data-bs-toggle={firstLogin ? '' : 'collapse'} 
            href="#"
            onClick={(e) => { e.preventDefault(); }}
            style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <i className="bi bi-arrow-left-right" />
            <span>Stock Transfers</span>
            <i className="bi bi-chevron-down ms-auto" />
          </a>
          <ul id="stock-transfers-nav" className={`nav-content ${isExpanded(['request-stock', 'pending-transfers', 'outgoing-transfers', 'incoming-transfers', 'transfer-history'])}`} data-bs-parent="#sidebar-nav">
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('request-stock'); }}
                className={isSubActive('request-stock')}
              >
                <i className="bi bi-circle" />
                <span>Request Stock</span>
              </a>
            </li>
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('pending-transfers'); }}
                className={isSubActive('pending-transfers')}
              >
                <i className="bi bi-circle" />
                <span>My Requests</span>
              </a>
            </li>
          
          
          </ul>
        </li>{/* End Stock Transfers Nav */}
        
        {/* Branch Stock Requests */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive(['branch-requests', 'requests-history'])} ${firstLogin ? 'disabled' : ''}`}
            data-bs-target="#branch-requests-nav" 
            data-bs-toggle={firstLogin ? '' : 'collapse'} 
            href="#"
            onClick={(e) => { e.preventDefault(); }}
            style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <i className="bi bi-clipboard-check" />
            <span>Branch Stock Requests</span>
            <i className="bi bi-chevron-down ms-auto" />
          </a>
          <ul id="branch-requests-nav" className={`nav-content ${isExpanded(['branch-requests', 'requests-history'])}`} data-bs-parent="#sidebar-nav">
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('branch-requests'); }}
                className={isSubActive('branch-requests')}
              >
                <i className="bi bi-circle" />
                <span>Requests</span>
              </a>
            </li>
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('requests-history'); }}
                className={isSubActive('requests-history')}
              >
                <i className="bi bi-circle" />
                <span>Requests History</span>
              </a>
            </li>
          </ul>
        </li>{/* End Branch Stock Requests Nav */}
        
        
        
        {/* Product List */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive('product-list')} ${firstLogin ? 'disabled' : ''}`}
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('product-list'); }}
            style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <i className="bi bi-list-ul" />
            <span>Product List</span>
          </a>
        </li>{/* End Product List Nav */}
        
        {/* Reports */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive('reports')} ${firstLogin ? 'disabled' : ''}`}
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('reports'); }}
            style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <i className="bi bi-file-earmark-text" />
            <span>Reports</span>
          </a>
        </li>{/* End Reports Nav */}
        
        {/* Profile */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive('profile')}`}
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('profile'); }}
          >
            <i className="bi bi-person" />
            <span>Profile</span>
          </a>
        </li>{/* End Profile Nav */}
      </ul>
    </aside>
  )
}

export default SideBar